import React, { useContext, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Stack } from '@mui/material';
import MoreProfileUser from 'components/shared/more-profile/MoreProfileUser';
import MoreProfileLogoutButton from 'components/shared/more-profile/MoreProfileLogoutButton';
import MoreTourButton from 'components/shared/more-profile/MoreTourButton';
import TrainerMoreHub from 'components/trainer/more/TrainerMoreHub';
import { userMembershipFields } from 'common/constants/query-fields/user';
import routes from 'common/routes';
import AppBarContext from 'context/AppBarContext';
import LayoutContext from 'context/LayoutContext';
import authSlice from 'store/modules/auth';

function TrainerMore() {
  const dispatch = useDispatch();
  const { setAppBarButton, setAppBarTitle } = useContext(AppBarContext);
  const { setCompactLayout, setNoBgColorLayout } = useContext(LayoutContext);

  useEffect(() => {
    setAppBarButton(null);
    setAppBarTitle(null);
  }, [setAppBarButton, setAppBarTitle]);

  useEffect(() => {
    setCompactLayout(true);
    setNoBgColorLayout(true);

    return () => {
      setCompactLayout(false);
      setNoBgColorLayout(false);
    };
  }, []);

  useEffect(() => {
    dispatch(authSlice.actions.me(userMembershipFields));
  }, [dispatch]);

  return (
    <Stack spacing={5}>
      <Stack spacing={2}>
        <MoreProfileUser profilePath={routes.trainerProfile.path} />
      </Stack>
      <Stack spacing={1}>
        <TrainerMoreHub />
      </Stack>
      <MoreTourButton />
      <MoreProfileLogoutButton />
    </Stack>
  );
}

export default TrainerMore;
